module.exports = __webpack_public_path__ + "static/Home-header-image-2b114f43a556487b67ef79b76055c1f3.png";